<template>
  <div>
    <Loading
      v-if="showLoading"
      :mensaje="$t('perfil.cargandoPerfilDelPrestadorEspere')"
    />
    <v-dialog v-model="showSucces" color="white" persistent width="500">
      <v-alert color="green" class="ma-0" dark prominent icon="mdi-check-bold">
        <span class="headline">{{ mensajeOk }}</span>
        <v-divider class="my-4 white" style="opacity: 0.22"></v-divider>
        <v-row no-gutters class="justify-end">
          <v-col class="shrink">
            <v-btn outlined @click="showSucces = false">
              {{ $t('perfil.cerrar') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>

    <v-dialog v-model="showError" persistent width="500">
      <v-card>
        <v-card-title class="headline red" primary-title
          >{{ $t('perfil.error') }}
        </v-card-title>
        <v-card-text class="body-1">
          {{ mensajeError }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="showError = false">
            {{ $t('perfil.aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showEditarPrestador" color="white" persistent>
      <v-form v-if="prestador !== null">
        <v-card>
          <v-card-title class="blue lighten-3">
            {{ $t('perfil.editarPrestador') }}
          </v-card-title>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="prestador.razon_social"
                  :hide-details="true"
                  :label="$t('perfil.razonSocial')"
                  :placeholder="$t('perfil.razonSocial')"
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="prestador.cuit"
                  :hide-details="true"
                  :label="$t('perfil.cuit')"
                  :placeholder="$t('perfil.cuit')"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="prestador.tp_prestador"
                  :hide-details="true"
                  :label="$t('perfil.tipoDePrestador')"
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="prestador.email"
                  :hide-details="true"
                  :label="$t('perfil.datosDelBanco')"
                  :placeholder="$t('perfil.datosDelBanco')"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="mx-1">
                  <v-autocomplete
                    v-model="prestador.marcas"
                    :items="marcas"
                    :label="$t('perfil.marcasComercializadas')"
                    chips
                    deletable-chips
                    hide-details
                    density="comfortable"
                    multiple
                    :menu-props="{ maxHeight: 200 }"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn
                  block
                  class="white--text"
                  color="primary"
                  @click="cancelarCambios()"
                >
                  <v-icon>mdi-backup-restore</v-icon>
                  <span class="ml-2">{{ $t('perfil.cancelar') }}</span>
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  :disabled="sinCambiosPorGuardar()"
                  block
                  class="white--text"
                  color="primary"
                  @click="guardarDatosPrestador()"
                >
                  <v-icon>mdi-content-save-outline</v-icon>
                  <span class="ml-2">{{ $t('perfil.guardar') }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="showModalObservacion"
      transition="dialog-top-transition"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="blue">{{
          $t('perfil.agregarUnaNota')
        }}</v-card-title>
        <v-divider class="my-1 info" style="opacity: 0.22" />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="nuevaObservacion"
                :label="$t('perfil.comentario')"
                filled
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            class="pa-2 mr-auto"
            color="primary"
            @click="showModalObservacion = false"
            >{{ $t('perfil.cancelar') }}
          </v-btn>
          <v-btn
            :disabled="nuevaObservacion === ''"
            color="primary"
            class="pa-2"
            @click="agregarObservacion()"
          >
            {{ $t('perfil.agregar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showViewImage"
      transition="dialog-top-transition"
      max-width="800"
    >
      <v-card>
        <v-toolbar color="primary" dark>{{
          $t('perfil.visualizarImagen')
        }}</v-toolbar>
        <v-img
          :src="previewFile && previewFile.id ? getFileUrl(previewFile.id) : ''"
          class="grey lighten-2"
          contain
        />
        <div class="text-center">
          {{ previewFile && previewFile.nombre ? previewFile.nombre : '' }}
        </div>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="showViewImage = false"
            >{{ $t('perfil.cerrar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showViewPdf" transition="dialog-top-transition">
      <v-card>
        <v-toolbar color="primary" dark>{{
          $t('perfil.visualizarPDF')
        }}</v-toolbar>
        <iframe
          :src="previewFile && previewFile.id ? getFileUrl(previewFile.id) : ''"
          height="600"
          width="100%"
        >
        </iframe>
        <div class="text-center">
          {{ previewFile && previewFile.nombre ? previewFile.nombre : '' }}
        </div>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="showViewPdf = false">{{
            $t('perfil.cerrar')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDownlodFile" max-width="500px" persistent>
      <v-card>
        <v-card-title>{{ $t('perfil.descargarArchivo') }} </v-card-title>
        <v-divider class="my-2 info" style="opacity: 0.22" />
        <v-card-text>
          <v-col>
            <v-btn
              class="mr-2 blue--text"
              color="blue-grey lighten-5"
              fab
              @click="downloadFile(previewFile)"
            >
              <v-icon dark>mdi-cloud-download-outline</v-icon>
            </v-btn>
            {{ previewFile && previewFile.nombre ? previewFile.nombre : '' }}
          </v-col>
        </v-card-text>
        <v-divider class="bt-0" />
        <v-card-actions>
          <v-btn
            class="pa-2 ml-auto"
            color="primary"
            @click="cerrarModalDownloadFile()"
            >Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalAdjuntarImagen" max-width="500px" persistent>
      <v-card>
        <v-card-title>{{ $t('perfil.adjuntarUnArchivo') }} </v-card-title>
        <v-divider class="my-2 info" style="opacity: 0.22" />
        <v-card-text>
          <v-col>
            <v-file-input
              id="attachFiles"
              v-model="fileToUpload"
              :rules="rules"
              accept=".pdf, .zip, .rar, image/*"
              :placeholder="$t('perfil.adjuntarArchivosALaSucursal')"
              :label="$t('perfil.adjuntarArchivos')"
              prepend-icon="mdi-paperclip"
              show-size
              counter
              clearable
            ></v-file-input>
          </v-col>
          <Loading
            v-if="uploadingFile"
            :mensaje="$t('perfil.subiendoArchivosAlServidor')"
          />
        </v-card-text>
        <v-divider class="bt-0" />
        <v-card-actions>
          <v-btn
            class="pa-2 mr-auto"
            color="primary"
            @click="cerrarModalAdjuntarImagen()"
            >{{ $t('perfil.cancelar') }}
          </v-btn>
          <v-btn
            :disabled="!validarInputFile()"
            color="primary"
            class="pa-2"
            @click="uploadFile()"
          >
            {{ $t('perfil.guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-window v-model="step" touchless>
      <v-window-item value="perfil">
        <div v-if="prestador === null && userPrestadores.length === 0">
          {{ $t('perfil.noHayDatosParaMostrarAsociadosAlUsuarioActual') }}
        </div>
        <div v-else>
          <div v-if="userPrestadores.length > 1">
            <v-select
              v-model="uuidPrestadorSelected"
              :items="userPrestadores"
              item-text="text"
              item-value="id"
              attach
              chips
              :label="$t('perfil.prestador')"
              :hint="$t('perfil.seleccioneUnPrestadorParaVerSusDatos')"
              persistent-hint
              class="body-2 font-weight-medium"
              :class="{ 'select-mb-250': uuidPrestadorSelected === null }"
              @change="seleccionarPrestador()"
            />
          </div>
          <v-card v-if="uuidPrestadorSelected !== null" class="mt-4">
            <v-card-title class="blue lighten-1">
              {{ namePrestadorSelected }}
            </v-card-title>
            <Loading
              v-if="showLoadingPrestador"
              :mensaje="$t('perfil.cargandoDatosDelPrestadorEspere')"
            />
            <div v-else>
              <v-form v-if="prestador !== null">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="prestador.razon_social"
                        :hide-details="true"
                        :label="$t('perfil.razonSocial')"
                        :placeholder="$t('perfil.razonSocial')"
                        outlined
                        readonly
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="prestador.cuit"
                        :hide-details="true"
                        :label="$t('perfil.cuit')"
                        :placeholder="$t('perfil.cuit')"
                        outlined
                        readonly
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="prestador.tp_prestador"
                        :hide-details="true"
                        :label="$t('perfil.tipoDePrestador')"
                        outlined
                        readonly
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="prestador.email"
                        :hide-details="true"
                        :label="$t('perfil.datosDelBanco')"
                        :placeholder="$t('perfil.datosDelBanco')"
                        outlined
                        readonly
                      />
                    </v-col>
                    <v-col cols="12" sm="10">
                      <v-select
                        v-model="prestador.marcas"
                        :items="marcas"
                        :hide-details="true"
                        attach
                        chips
                        :label="$t('perfil.marcasComercializadas')"
                        multiple
                        outlined
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="6">
                      <v-btn
                        block
                        class="white--text"
                        color="success"
                        @click="showEditarPrestador = true"
                      >
                        <v-icon>mdi-text-box-edit-outline</v-icon>
                        <span class="ml-2">{{ $t('perfil.editar') }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel key="1">
                  <v-expansion-panel-header class="blue lighten-3">
                    <h3>{{ $t('perfil.sucursales') }}</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12">
                        <v-simple-table>
                          <template #default>
                            <thead>
                              <tr class="text-left">
                                <th class="px-0"></th>
                                <th
                                  class="text-left text-xs-caption text-sm-body-2 font-weight-medium td_width_40"
                                >
                                  {{ $t('perfil.razonSocial') }}
                                </th>
                                <th
                                  class="text-xs-caption text-sm-body-2 font-weight-medium pl-0"
                                >
                                  {{ $t('perfil.provincia') }}
                                </th>
                                <th
                                  class="text-xs-caption text-sm-body-2 font-weight-medium pl-0"
                                >
                                  {{ $t('perfil.localidad') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <v-hover
                                v-for="sucursal in prestadorSucursales"
                                :key="sucursal.id"
                                v-slot="{ hover }"
                              >
                                <tr
                                  :key="sucursal.id"
                                  class="text-left"
                                  @click="irVentanaSucursal(sucursal.id)"
                                >
                                  <td class="px-0">
                                    <v-icon v-if="hover" color="primary">
                                      mdi-eye
                                    </v-icon>
                                    <v-icon v-else color="primary">
                                      mdi-eye-outline
                                    </v-icon>
                                  </td>
                                  <td class="text-xs-caption text-sm-body-2">
                                    {{ sucursal.razon_social }}
                                  </td>
                                  <td
                                    class="text-xs-caption text-sm-body-2 pl-0"
                                  >
                                    {{ sucursal.provincia_nombre }}
                                  </td>
                                  <td
                                    class="text-xs-caption text-sm-body-2 pl-0"
                                  >
                                    {{ capitalize(sucursal.localidad_nombre) }}
                                  </td>
                                </tr>
                              </v-hover>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel key="2">
                  <v-expansion-panel-header class="blue lighten-3">
                    <h3>{{ $t('perfil.adjuntos') }}</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-alert
                      v-if="prestador.files.length === 0"
                      color="blue"
                      border="left"
                      elevation="2"
                      colored-border
                      icon="mdi-information-outline"
                      class="text-left mt-2"
                    >
                      {{ $t('perfil.noSeEncontraronAdjuntos') }}
                    </v-alert>
                    <v-row>
                      <v-col cols="12">
                        <v-list-item
                          v-for="adjunto in prestador.files"
                          :key="adjunto.id"
                        >
                          <v-list-item-avatar size="60">
                            <v-img
                              v-if="adjunto.mime.startsWith('image')"
                              :src="getFileUrl(adjunto.id)"
                              aspect-ratio="1"
                              class="grey lighten-4"
                            >
                              <template #placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="green lighten-2"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-img
                              v-else-if="adjunto.mime === 'application/pdf'"
                              src="/icon_file_pdf.jpg"
                              aspect-ratio="2"
                              :alt="$t('perfil.iconoArchivoPDF')"
                            ></v-img>
                            <v-img
                              v-else-if="
                                [
                                  'application/zip',
                                  'application/octet-stream'
                                ].includes(adjunto.mime)
                              "
                              src="/icon_file_rar.png"
                              aspect-ratio="2"
                              :alt="$t('perfil.iconoArchivoComprimido')"
                            >
                            </v-img>
                            <v-img
                              v-else
                              src="/icon_file_other.png"
                              aspect-ratio="2"
                              :alt="$t('perfil.iconoArchivoSinEspecificar')"
                            >
                            </v-img>
                          </v-list-item-avatar>
                          <v-list-item-content
                            class="text-left"
                            @click="openPreviewFile(adjunto)"
                          >
                            <v-list-item-title>
                              {{ adjunto.filedesc }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ adjunto.created_at }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn
                          block
                          class="white--text"
                          color="primary"
                          @click="mostrarModalAdjuntarImagen()"
                        >
                          <v-icon>mdi-file-upload-outline</v-icon>
                          <span class="ml-2">{{ $t('perfil.adjuntar') }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel key="3">
                  <v-expansion-panel-header class="blue lighten-3">
                    <h3>{{ $t('perfil.notas') }}</h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card class="mx-auto text-left mt-2" tile>
                      <v-alert
                        v-if="notasPrestador.length === 0"
                        color="blue"
                        border="left"
                        elevation="2"
                        colored-border
                        icon="mdi-information-outline"
                        class="mt-2"
                      >
                        {{ $t('perfil.noSeEncontraronRegistros') }}
                      </v-alert>
                      <v-list v-else>
                        <v-list-item
                          v-for="(nota, index) in notasPrestador"
                          :key="index"
                          two-line
                        >
                          <v-list-item-content>
                            <v-divider />
                            <v-list-item-subtitle class="text-wrap">
                              {{ nota.created_at }} -
                              <span class="black--text">{{
                                nota.usuario
                              }}</span>
                            </v-list-item-subtitle>
                            <v-list-item-title class="text-wrap">
                              {{ nota.texto }}
                            </v-list-item-title>
                            <v-list-item
                              v-for="(respuesta, rindex) in nota.respuestas"
                              :key="rindex"
                              class="pr-0"
                            >
                              <v-list-item-content>
                                <v-divider />
                                <v-list-item-subtitle class="text-wrap">
                                  {{ respuesta.created_at }} -
                                  <span class="black--text">
                                    {{ respuesta.usuario }}
                                  </span>
                                </v-list-item-subtitle>
                                <v-list-item-title class="text-wrap">
                                  {{ respuesta.texto }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>
                    <v-row>
                      <v-col cols="12">
                        <v-btn
                          block
                          class="white--text"
                          color="primary"
                          @click="mostrarModalAgregarObservacion()"
                        >
                          <v-icon>mdi-pen-plus</v-icon>
                          <span class="ml-2">{{ $t('perfil.nota') }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-card>
        </div>
      </v-window-item>
      <v-window-item value="sucursal">
        <v-card>
          <v-card-title class="primary">
            <v-btn
              icon
              class="blue lighten-1 white--text mr-2"
              @click="irVentanaPerfil()"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            {{ $t('perfil.datosDeLaSucursal') }}
          </v-card-title>
        </v-card>
        <div v-if="idSucursalSelecto === null">
          <v-alert
            color="blue"
            border="left"
            elevation="2"
            colored-border
            icon="mdi-information-outline"
            class="mt-4"
          >
            <p
              :class="$vuetify.breakpoint.smAndDown ? 'text-body1' : 'text-h6'"
            >
              {{
                $t(
                  'perfil.debeSeleccionarPreviamenteUnaSucursalParaVerSusDatos'
                )
              }}
            </p>
          </v-alert>
        </div>
        <sucursal-form v-else :sucursal-id="idSucursalSelecto" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import serviceArticulo from '~/services/serviceArticulo'
import servicePrestador from '~/services/servicePrestador'
import Loading from '~/components/Loading.vue'
import SucursalForm from '~/components/prestador/Sucursal.vue'

const MAX_SIZE_UPLOAD = 4000000

const TIPO_PRESTADOR = [
  'Concesionario',
  'Mixto',
  'Cristales Automotor',
  'Neumáticos'
]

export default {
  name: 'Perfil',
  components: { Loading, SucursalForm },
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      userPrestadores: [],
      selectUserPrestadores: [],
      namePrestadorSelected: null,
      uuidPrestadorSelected: null,
      prestador: null,
      prestadorBk: null,
      prestadorSucursales: [],
      notasPrestador: [],
      showLoading: false,
      mensajeLoadingPrestador: '',
      showLoadingPrestador: false,
      showEditarPrestador: false,
      showModalObservacion: false,
      nuevaObservacion: '',
      showError: false,
      mensajeError: '',
      showSucces: false,
      mensajeOk: '',
      marcas: null,
      tiposPrestadores: TIPO_PRESTADOR,
      panel: [],
      showViewImage: false,
      showViewPdf: false,
      showDownlodFile: false,
      previewFile: null,
      fileToUpload: [],
      modalAdjuntarImagen: false,
      uploadingFile: false,
      step: 'perfil',
      idSucursalSelecto: null,
      nombreSucursalSelecto: '',
      rules: [
        (value) =>
          !value ||
          value.length === 0 ||
          value.size < MAX_SIZE_UPLOAD ||
          'El archivo no puede ser superar los 4Mb!'
      ]
    }
  },
  created() {
    this.getMarcas()
    this.getListaUserPrestador()
  },
  methods: {
    async getMarcas() {
      try {
        this.showLoading = true
        const responseMarcas = await serviceArticulo.getListadoMarcas(
          this.$config.axiosParams
        )
        this.marcas = Object.values(responseMarcas.data).map((m) => {
          return m
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoading = false
          this.showError = true
          this.mensajeError = `Error al obtener datos de las marcas. ${error}`
        }
      }
    },
    async getListaUserPrestador() {
      try {
        this.showLoading = true

        const responsePrestador = await servicePrestador.getPrestadores(
          this.$config.axiosParams
        )
        this.userPrestadores = responsePrestador.data
        if (this.userPrestadores.length === 1) {
          this.uuidPrestadorSelected = this.userPrestadores[0].id
          this.namePrestadorSelected = this.userPrestadores[0].text
          this.getDatosPrestador()
        }
        this.selectUserPrestadores = this.userPrestadores.map(
          (prestador) => prestador.text
        )
        this.showLoading = false
      } catch (error) {
        if (error.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoading = false
          this.showError = true
          this.mensajeError = `Error al guardar los datos del prestador. ${error}`
        }
      }
    },
    seleccionarPrestador() {
      const index = this.userPrestadores
        .map((p) => p.id)
        .indexOf(this.uuidPrestadorSelected)
      this.namePrestadorSelected = this.userPrestadores[index].text
      this.getDatosPrestador()
    },
    async getDatosPrestador() {
      this.showLoadingPrestador = true
      this.getListaSucursalesPrestador()
      const response = await servicePrestador.get(
        this.$config.axiosParams,
        this.uuidPrestadorSelected
      )
      this.prestador = response.data
      this.prestadorBk = { ...this.prestador }
      this.notasPrestador = this.prestador.solicitudes.filter(
        (solicitud) => solicitud.usuario === this.user.name
      )
      this.showLoadingPrestador = false
    },
    async guardarDatosPrestador() {
      try {
        this.showLoadingPrestador = true
        await servicePrestador.guardarPrestador(
          this.$config.axiosParams,
          this.uuidPrestadorSelected,
          this.prestador
        )
        this.showEditarPrestador = false
        this.showSucces = true
        this.mensajeOk = 'Se guardaron los datos del prestador con Exito.'
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showEditarPrestador = false
          this.showLoadingPrestador = false
          this.showError = true
          this.mensajeError = `Error al guardar los datos del prestador. ${error}`
        }
      }
      this.crearSolicitudCambiosPrestador()
      this.getDatosPrestador()
    },
    async getListaSucursalesPrestador() {
      try {
        const response = await servicePrestador.getSucursales(
          this.$config.axiosParams,
          this.uuidPrestadorSelected
        )
        this.prestadorSucursales = response.data
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showError = true
          this.mensajeError = `Error al obtener la/s sucursales para el prestador. ${error}`
        }
      }
    },
    cancelarCambios() {
      this.prestador = { ...this.prestadorBk }
      this.showEditarPrestador = false
    },
    sinCambiosPorGuardar() {
      if (this.prestador === null && this.prestadorBk === null) {
        return true
      }
      const aKeys = Object.keys(this.prestador).sort()
      const bKeys = Object.keys(this.prestadorBk).sort()
      if (aKeys.length !== bKeys.length) {
        return false
      }
      if (aKeys.join('') !== bKeys.join('')) {
        return false
      }
      for (let i = 0; i < aKeys.length; i++) {
        if (this.prestador[aKeys[i]] !== this.prestadorBk[bKeys[i]]) {
          return false
        }
      }
      return true
    },
    mostrarModalAgregarObservacion() {
      this.nuevaObservacion = ''
      this.showModalObservacion = true
    },
    async agregarObservacion() {
      this.showModalObservacion = false
      this.showLoading = true
      const observacion = {
        solicitud: this.nuevaObservacion
      }
      try {
        await servicePrestador.agregarObservacion(
          this.$config.axiosParams,
          this.uuidPrestadorSelected,
          observacion
        )
        this.getDatosPrestador()
        this.showLoading = false
        this.mensajeOk = 'Se agregó correctamente la observación.'
        this.showSucces = true
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.showLoading = false
          this.mensajeError = `Error al agregar la observación. ${error}`
          this.showError = true
        }
      }
    },
    openPreviewFile(file) {
      this.previewFile = { id: file.id, nombre: file.filedesc }
      if (file.mime.startsWith('image')) {
        this.showViewImage = true
        return
      }
      if (file.mime === 'application/pdf') {
        this.showViewPdf = true
        return
      }
      this.showDownlodFile = true
    },
    getFileUrl(idFile) {
      return `${this.$config.axiosParams.baseURL}/api/v1/portal/prestador/${this.uuidPrestadorSelected}/upload/${idFile}`
    },
    mostrarModalAdjuntarImagen() {
      this.fileToUpload = []
      this.modalAdjuntarImagen = true
    },
    cerrarModalAdjuntarImagen() {
      this.modalAdjuntarImagen = false
    },
    validarInputFile() {
      if (this.fileToUpload === null || this.fileToUpload.length === 0) {
        return false
      }
      if (this.fileToUpload.size > MAX_SIZE_UPLOAD) {
        return false
      }

      return true
    },
    async uploadFile() {
      if (!this.validarInputFile()) {
        return
      }

      try {
        this.uploadingFile = true
        const formData = new FormData()
        formData.append('file', this.fileToUpload)
        await servicePrestador.uploadFile(
          this.$config.axiosParams,
          this.uuidPrestadorSelected,
          formData
        )
        this.uploadingFile = false
        this.modalAdjuntarImagen = false
        this.showSucces = true
        this.mensajeOk = 'Carga de archivo/s exitosa.'
        this.crearSolicitudNuevosAdjuntos()
        this.getDatosPrestador()
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          this.uploadingFile = false
          this.modalAdjuntarImagen = false
          this.mensajeError = `Error al subir archivo. Intente subirlo nuevamente. ${error}`
          this.showError = true
        }
      }
    },
    irVentanaSucursal(idSucursal) {
      this.idSucursalSelecto = idSucursal
      this.step = 'sucursal'
    },
    irVentanaPerfil() {
      this.idSucursalSelecto = null
      this.step = 'perfil'
      this.getDatosPrestador()
    },
    cerrarModalDownloadFile() {
      this.showDownlodFile = false
      this.previewFile = null
    },
    downloadFile(file) {
      const link = document.createElement('a')
      link.setAttribute('href', this.getFileUrl(file.id))
      link.setAttribute('download', file.nombre)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.showDownlodFile = false
    },
    async crearSolicitudNuevosAdjuntos() {
      const observacion = {
        solicitud: `Prestador agrega adjunto/s a su perfil: ${this.fileToUpload.name}`
      }
      try {
        await servicePrestador.agregarObservacion(
          this.$config.axiosParams,
          this.uuidPrestadorSelected,
          observacion
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    },
    async crearSolicitudCambiosPrestador() {
      const observacion = {
        solicitud: `Se modifica datos del perfil del Prestador ${
          this.namePrestadorSelected
        }. Valor anterior marcas: ${this.prestadorBk.marcas.toString()}`
      }
      try {
        await servicePrestador.agregarObservacion(
          this.$config.axiosParams,
          this.uuidPrestadorSelected,
          observacion
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$router.push('/login')
        } else {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    },
    capitalize(cadena) {
      return cadena
        .toLowerCase()
        .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase())
    }
  }
}
</script>
<style scoped>
.select-mb-250 {
  margin-bottom: 250px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
  background: #f5f5f5 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  background: none !important;
}

@media (max-width: 600px) {
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.75rem !important;
  }
}

.td_width_40 {
  width: 40%;
}
</style>
